<template>
  <div class="notificationBoard">
    <div class="header">
      <div class="header_title">公告列表</div>
      <div class="header_count">共 {{ noticeMap.totalCount }} 条·未读 {{ noticeMap.unreadCount }}</div>
    </div>
    <div class="type_list">
      <div v-for="(item, index) in typeList" :key="index" :class="{ 'type_item': true, 'active': item.value === form.announcementType }" @click="typeChange(item.value)">{{ item.label }}</div>
    </div>
    <div class="status_list">
      <div v-for="(item, index) in statusList" :key="index" :class="{ 'status_item': true, 'active': item.value === form.readStatus }" @click="statusChange(item.value)">{{ item.label }}</div>
    </div>
    <div class="content">
      <div v-for="notice in list" :key="notice.announcementId" class="notice" @click="toNoticeView(notice.announcementId)">
        <div class="notice_header">
          <div class="notice_header_left">
            <div v-if="!notice.read" class="notice_header_left_noRead"></div>
            <div v-if="notice.top" class="notice_header_left_top">置顶</div>
            <div class="notice_header_left_title">{{ notice.title }}</div>
          </div>
          <div class="notice_header_right">{{ notice.publishTime }}</div>
        </div>
        <div class="notice_content">{{ notice.contentSummary }}</div>
      </div>
      <el-empty v-if="list.length === 0" description="暂无公告"></el-empty>
    </div>
    <div class="footer">
      <el-pagination
        layout="total, prev, pager, next"
        :current-page="form.pageNum"
        :page-size="form.pageSize"
        :total="total"
        @current-change="pageNumChange">
      </el-pagination>
    </div>
    <notificationView ref="notificationView" @update="updateList"></notificationView>
  </div>
</template>

<script>
  import req from '@/utils/request'

  import notificationView from './components/notificationView.vue'
  export default {
    name: 'notificationBoard',
    components: {
      notificationView
    },
    data() {
      return {
        typeList: [
          { label: '全部', value: '' },
          { label: '系统更新', value: '1' },
          { label: '运营通知', value: '2' }
        ],
        statusList: [
          { label: '全部', value: '' },
          { label: '未读', value: '0' },
          { label: '已读', value: '1' }
        ],
        form: {
          announcementType: '',
          readStatus: '',
          pageNum: 1,
          pageSize: 10
        },
        list: [],
        total: 0
      }
    },
    computed: {
      noticeMap () {
        return this.$store.state.noticeMap
      }
    },
    created () {
      this.$store.dispatch('getNoticeNum')
      this.getList()
    },
    mounted () {
      if (sessionStorage.getItem('noticeId')) {
        this.toNoticeView(sessionStorage.getItem('noticeId'))
        sessionStorage.removeItem('noticeId')
      }
    },
    methods: {
      async getList () {
        const res = await req.post('/announcement/employee/page', this.form)
        if (res.code === 200) {
          this.list = res.rows
          this.total = res.total
        }
      },
      pageNumChange (pageNum) {
        this.form.pageNum = pageNum
        this.getList()
      },
      typeChange (value) {
        this.form.announcementType = value
        this.form.readStatus = ''
        this.getList()
      },
      statusChange (value) {
        this.form.readStatus = value
        this.getList()
      },
      toNoticeView (id) {
        this.$refs.notificationView.open(id)
      },
      updateList () {
        this.getList()
      }
    }
  }
</script>

<style lang="less" scoped>
  .notificationBoard {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    user-select: none;
  }

  .header {
    flex-shrink: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    width: 100%;
    height: 48px;
    background-color: #FFFFFF;
    border-bottom: 1px solid #EBEAEE;
  }

  .header_title {
    font-weight: 600;
    font-size: 16px;
    color: #000000;
  }

  .header_count {
    font-size: 14px;
    color: #667182;
  }

  .type_list {
    flex-shrink: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 40px;
    background-color: #FFFFFF;
    border-bottom: 1px solid #EBEAEE;
  }

  .type_item {
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 24px;
    height: 100%;
    font-size: 14px;
    color: #667182;
    cursor: pointer;
  }

  .type_item.active {
    color: #1f2329;
  }

  .type_item.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #1890ff;
  }

  .status_list {
    flex-shrink: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 24px;
    width: 100%;
    height: 40px;
  }

  .status_item {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 16px;
    height: 24px;
    font-size: 12px;
    color: #667182;
    border: 1px solid #667182;
    border-radius: 4px;
    cursor: pointer;
  }

  .status_item + .status_item {
    margin: 0 0 0 12px;
  }

  .status_item.active {
    color: #FFFFFF;
    background-color: #1890ff;
    border-color: #1890ff;
  }

  .content {
    flex-grow: 1;
    box-sizing: border-box;
    width: 100%;
    min-height: 0px;
    background-color: #FFFFFF;
    border-top: 1px solid #EBEAEE;
    border-bottom: 1px solid #EBEAEE;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .notice {
    box-sizing: border-box;
    padding: 16px 24px;
    width: 100%;
    border-bottom: 1px solid #EBEAEE;
  }

  .notice:hover {
    background-color: #f5f7fa;
  }

  .notice_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .notice_header_left {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .notice_header_left_noRead {
    position: absolute;
    z-index: 2;
    top: 6px;
    left: -12px;
    width: 6px;
    height: 6px;
    background-color: #f54a45;
    border-radius: 50%;
  }

  .notice_header_left_top {
    margin: 0 4px 0 0;
    padding: 1px 4px;
    font-size: 12px;
    color: #E6A23C;
    background-color: #faecd8;
    border: 1px solid #E6A23C;
    border-radius: 4px;
  }

  .notice_header_left_title {
    line-height: 20px;
    font-weight: 600;
    font-size: 16px;
    color: #000000;
  }

  .notice_header_right {
    font-size: 14px;
    color: #667182;
  }

  .notice_content {
    margin: 6px 0 0 0;
    line-height: 20px;
    font-size: 14px;
    color: #333333;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .footer {
    flex-shrink: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 24px;
    width: 100%;
    height: 40px;
    background-color: #FFFFFF;
  }
</style>
